module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(9).430a729d.png";